export default "__VITE_ASSET__oIwIGb5L__"